import { render } from "./page5.vue?vue&type=template&id=9ee289f2&scoped=true"
import script from "./page5.vue?vue&type=script&lang=js"
export * from "./page5.vue?vue&type=script&lang=js"

import "./page5.vue?vue&type=style&index=0&id=9ee289f2&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ee289f2"]])

export default __exports__